export const ON_CLICK_MARKER_EVENT = 'clickmarker';
